import { Avatar, Flex, Menu } from "@mantine/core";
import styles from "./index.module.scss";
import { Link, useNavigate } from "react-router";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { LogOutService } from "@/service";

export default function Header() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<any>({});

  useEffect(() => {
    if (localStorage.getItem("userInfo")) {
      const info = localStorage.getItem("userInfo");
      if (info && info !== "undefined") {
        const userInfo = JSON.parse(info || "{}");
        setUserInfo(userInfo);
      }
    }
  }, [localStorage.getItem("userInfo")]);

  const handleLogout = async () => {
    await LogOutService();
    Cookies.remove("token");
    localStorage.removeItem("userInfo");
    Cookies.remove("monitor_key");
    navigate("/login");
  };

  return (
    <div className={styles.header}>
      <Flex justify={"space-between"} align="center" w={"100%"} p="lg">
        <a onClick={() => window.open("/app/")}>
          <img
            src="https://img.monitrees.com/logo/logo.png"
            width={180}
            style={{ marginTop: 5 }}
          />
        </a>

        <Menu shadow="md" width={180} position="bottom-end" withArrow>
          <Menu.Target>
            <Avatar
              name={userInfo?.email}
              alt="user"
              radius="xl"
              color="dark"
              style={{ cursor: "pointer" }}
            />
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item onClick={() => window.open("/app/settings")}>
              Settings
            </Menu.Item>
            <Menu.Item onClick={handleLogout}>Log out</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Flex>
    </div>
  );
}
